import React from "react";
import { ButtonProps } from "./type";
import "../../styles/button.scss";

const Button = ({
  type,
  style,
  label,
  icon,
  onClick,
  outline,
  size,
  positionIcon,
  customClassName,
}: ButtonProps) => {
  const sizeClass = `button-${size}`;
  const className = outline
    ? `${type}-outline ${sizeClass} ${customClassName}`
    : `${type} ${sizeClass} ${customClassName}`;
  const iconView = icon ? (
    <i className={`material-icons position-${positionIcon}`}>{icon}</i>
  ) : null;
  return (
    <div className={className} style={style} onClick={onClick}>
      {positionIcon === "left" && iconView}
      <span>{label}</span>
      {positionIcon === "right" && iconView}
    </div>
  );
};

Button.defaultProps = {
  type: 'default',
  style: {},
  size: 'medium',
  positionIcon: 'left'
};

export default Button;
